import { FIELDS_CONFIG } from '../config';
export var showField = function showField(fieldName, analysis) {
  var fieldRule = FIELDS_CONFIG[fieldName];
  if (fieldRule.includes('*')) return true;
  return fieldRule.includes(analysis);
};